<template>
  <VContent>
    <VLayout
      align-center
      justify-center>
      <VProgressCircular
        indeterminate
        color="primary" />
    </VLayout>
  </VContent>
</template>

<script>
export default {
  name: 'LoadSpinner',
};
</script>

<style scoped>

</style>
